import { useState } from 'react';
import { Card, Container, Row, Col, Button } from 'react-bootstrap';
import { UploadBox } from './UploadBox';

export const UploadRepeater = ({
	setAnswer,
	answer,
	attachments,
	setAttachments,
	maxFileSize = 5,
}) => {
	const [currAttachments, setCurrAttachments] = useState(attachments);
	const [fileToLargeErr, setFileToLargeErr] = useState(false);

	function handleValidFileUpload(newFile, idx) {
		setFileToLargeErr(false);
		const newAttachments = currAttachments;
		newAttachments[idx] = newFile;
		setCurrAttachments([...newAttachments]);
		setAttachments([...newAttachments]);
	}

	const handleInvalidFileUpload = () => {
		setFileToLargeErr(true);
	};

	function addNewUpload() {
		setCurrAttachments(perviousAttachments => [
			...perviousAttachments,
			{ file: {} },
		]);
		setAttachments(perviousAttachments => [
			...perviousAttachments,
			{ file: {} },
		]);
	}

	function removeUpload(id) {
		setCurrAttachments([
			...currAttachments.slice(0, id),
			...currAttachments.slice(id + 1),
		]);
		setAttachments([
			...currAttachments.slice(0, id),
			...currAttachments.slice(id + 1),
		]);
	}

	function commitChange(file, idx) {
		const newFiles = [...currAttachments];
		newFiles[idx] = file;
		setCurrAttachments(newFiles);
		setAttachments(newFiles);
	}

	const calcFileSize = newFile =>
		parseFloat(newFile.size / (1024 * 1024)).toFixed(2);

	return (
		<Container className=" mt-5">
			<Row className="mb-4 d-flex">
				<Col xs="12" md="6">
					<Card
						onClick={() => setAnswer(true)}
						style={answer ? { border: 'solid #0074d9 2px' } : {}}>
						<Card.Body>
							<Card.Title>Yes</Card.Title>
						</Card.Body>
					</Card>
				</Col>
				<Col xs="12" md="6">
					<Card
						onClick={() => setAnswer(false)}
						style={answer === false ? { border: 'solid #0074d9 2px' } : {}}>
						<Card.Body>
							<Card.Title>No</Card.Title>
						</Card.Body>
					</Card>
				</Col>
			</Row>

			{answer && (
				<div>
					{currAttachments.map((file, idx) => {
						return (
							<div key={idx}>
								<UploadBox
									enableRemove={idx === 0 ? false : true}
									file={file}
									id={idx}
									commitChange={commitChange}
									handleRemove={removeUpload}
									fileToLargeErr={fileToLargeErr}
									calcFileSize={calcFileSize}
									handleInvalidFileUpload={handleInvalidFileUpload}
									handleValidFileUpload={handleValidFileUpload}
									maxFileSize={maxFileSize}
								/>
							</div>
						);
					})}
					<Button
						className="float-right col-sm-12 col-md-4 mt-4 mb-4"
						size="lg"
						onClick={addNewUpload}
						block>
						Add Attachment
					</Button>
				</div>
			)}
		</Container>
	);
};
